import React from 'react';
import { Users, CheckCircle2, XCircle, TrendingUp, UserX, AlertCircle } from 'lucide-react';
import { StatCard } from '../../../../shared/components/cards/StatCard';
import type { StatCardProps } from '../../../../shared/components/cards/StatCard';
import type { SegmentStats, MetricMode } from './types';

interface SummaryCardsProps {
  stats: SegmentStats;
  metricMode: MetricMode;
  label: string;
}

const SummaryCards: React.FC<SummaryCardsProps> = function ({ stats, metricMode, label }) {
  const cards: Array<Pick<StatCardProps, 'title' | 'value' | 'icon' | 'color'> & { subtitle?: string }> = [
    {
      title: 'Registered',
      value: (stats.totalRegistered ?? stats.totalStudents).toLocaleString(),
      icon: <Users className="w-5 h-5" />,
      color: 'purple',
    },
  ];
  if (metricMode !== 'pi') {
    cards.push({
      title: 'Pass %',
      value: stats.passPercentage + '%',
      subtitle: stats.totalPassed != null
        ? stats.totalPassed.toLocaleString() + ' passed'
        : Math.round(stats.totalStudents * stats.passPercentage / 100).toLocaleString() + ' passed',
      icon: <CheckCircle2 className="w-5 h-5" />,
      color: 'green',
    });
  }
  if (metricMode !== 'passStats') {
    cards.push({
      title: 'Performance Index',
      value: stats.performanceIndex,
      icon: <TrendingUp className="w-5 h-5" />,
      color: 'pink',
    });
  }
  if (metricMode !== 'pi') {
    cards.push(
      {
        title: 'Compartment',
        value: (stats.totalCompartment ?? Math.round(stats.totalStudents * 0.04)).toLocaleString(),
        subtitle: stats.totalCompartment != null ? undefined : '~4%',
        icon: <XCircle className="w-5 h-5" />,
        color: 'orange',
      },
      {
        title: 'Absent',
        value: (stats.totalAbsent ?? Math.round(stats.totalStudents * 0.03)).toLocaleString(),
        subtitle: stats.totalAbsent != null ? undefined : '~3%',
        icon: <UserX className="w-5 h-5" />,
        color: 'blue',
      },
      {
        title: 'Essential Repeater',
        value: (stats.totalEssentialRepeat ?? 0).toLocaleString(),
        icon: <AlertCircle className="w-5 h-5" />,
        color: 'red',
      },
    );
  }
  return (
    <div className={'grid gap-4 grid-cols-2 ' + (cards.length <= 4 ? 'md:grid-cols-4' : 'md:grid-cols-3 lg:grid-cols-6')}>
      {cards.map(function (c) {
        return (
          <StatCard
            key={c.title}
            title={c.title}
            value={c.value}
            subtitle={(c as any).subtitle}
            icon={c.icon}
            color={c.color}
          />
        );
      })}
    </div>
  );
};

export default SummaryCards;
